import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getUtenti, salvaUtente, eliminaUtente, impostaPermessoMappatura, impostaAziendaUtente,
  impostaModuliUtente, getAziende, getRisorseAdmin, assegnaAziendeRisorsa,
  getLegendaSviluppi, salvaSviluppiAzienda, eliminaSviluppoAzienda,
} from "./api";

// Chiave di raggruppamento per un utente senza azienda assegnata (stringa
// vuota): un valore che non collide mai con un vero nome azienda.
const SENZA_AZIENDA = " senza-azienda";

const MODULI_ELENCO = [
  { chiave: "diba", etichetta: "Import Distinte Basi", etichettaBreve: "Distinta Base", icona: "🧾" },
  { chiave: "ordini", etichetta: "Import Ordini", etichettaBreve: "Ordini", icona: "📦" },
  { chiave: "ddt", etichetta: "Import DDT", etichettaBreve: "DDT", icona: "🚚" },
];

export default function PannelloImpostazioni({ onClose }) {
  const navigate = useNavigate();
  const [utenti, setUtenti] = useState([]); // [{ username, puoMappare, azienda, moduliAttivi }] — bozza: i toggle/campi cambiano solo questa
  const [utentiOriginali, setUtentiOriginali] = useState([]); // ultimo stato confermato dal server, per capire cosa è cambiato
  const [caricamento, setCaricamento] = useState(true);
  // Creare un'azienda e aggiungere un utente a una già esistente erano lo
  // stesso identico form (un campo "Azienda" a testo libero, con autocomplete
  // sulle aziende note): confuso, capitava di non capire se si stava
  // creando qualcosa di nuovo o aggiungendo a un'azienda già lì. Ora sono due
  // percorsi distinti, ma condividono lo stesso "form" sotto — solo
  // "formAttivo" cambia se compare anche il campo nome azienda (creazione) o
  // no (l'azienda è già quella della tab aperta, implicita). Non esiste un
  // vero concetto di "azienda" lato server: resta dedotta dagli utenti (vedi
  // gruppiAzienda più sotto), quindi "creare un'azienda" in pratica crea il
  // suo primo utente.
  const [formAttivo, setFormAttivo] = useState(null); // null | "azienda" | "utente"
  const [campoAzienda, setCampoAzienda] = useState(""); // solo per formAttivo === "azienda"
  const [campoUsername, setCampoUsername] = useState("");
  const [campoPassword, setCampoPassword] = useState("");
  const [salvataggio, setSalvataggio] = useState(false);
  const [errore, setErrore] = useState("");
  const [messaggio, setMessaggio] = useState("");
  const [salvataggioPermessi, setSalvataggioPermessi] = useState(false);
  const [messaggioPermessi, setMessaggioPermessi] = useState("");

  // Tab attiva nella lista utenti: quale azienda è mostrata. Raggruppato
  // sull'azienda ORIGINALE (utentiOriginali, non la bozza) apposta: così
  // modificare il campo "Azienda" di un utente non lo fa sparire dalla tab
  // corrente mentre si scrive, resta lì finché non si salva davvero.
  const [tabAzienda, setTabAzienda] = useState(null);

  // Elenco aziende note (dedotto dagli utenti esistenti): solo per
  // l'autocompletamento dei campi azienda qui sotto, testo libero comunque.
  const [aziendeNote, setAziendeNote] = useState([]);

  // Template/modelli PDF già salvati (di ogni modulo/cliente), con le
  // aziende a cui sono attualmente assegnati — vedi routes/admin.js. Serve
  // soprattutto per assegnare alle aziende giuste i record salvati PRIMA che
  // esistesse questo concetto (invisibili finché non assegnati).
  const [risorse, setRisorse] = useState([]);
  const [caricamentoRisorse, setCaricamentoRisorse] = useState(true);
  const [erroreRisorse, setErroreRisorse] = useState("");

  // Unico altro modo di chiudere oltre alla ✕: un click sullo sfondo NON
  // chiude più (vedi sotto), per non buttare via per sbaglio delle modifiche
  // fatte a metà.

  // Niente più seconda password per aprire il pannello: solo wtrendy vede
  // anche solo la voce "Impostazioni" nel menu (vedi App.js), quindi essere
  // già loggati come wtrendy è già di per sé l'unico controllo d'accesso che
  // serve — chiederne un'altra qui era ridondante.
  useEffect(() => { ricarica(); ricaricaAziende(); ricaricaRisorse(); }, []);

  function ricaricaAziende() {
    getAziende().then(setAziendeNote).catch(() => {});
  }

  function ricaricaRisorse() {
    setCaricamentoRisorse(true);
    setErroreRisorse("");
    getRisorseAdmin()
      .then(setRisorse)
      .catch((e) => setErroreRisorse(e.message))
      .finally(() => setCaricamentoRisorse(false));
  }

  function ricarica() {
    setCaricamento(true);
    setMessaggioPermessi("");
    getUtenti()
      .then((elenco) => {
        setUtenti(elenco);
        setUtentiOriginali(elenco);
      })
      .catch((e) => setErrore(e.message))
      .finally(() => setCaricamento(false));
  }

  function apriFormNuovaAzienda() {
    setFormAttivo("azienda");
    setCampoAzienda("");
    setCampoUsername("");
    setCampoPassword("");
    setErrore("");
    setMessaggio("");
  }

  function apriFormNuovoUtente() {
    setFormAttivo("utente");
    setCampoUsername("");
    setCampoPassword("");
    setErrore("");
    setMessaggio("");
  }

  function chiudiForm() {
    setFormAttivo(null);
    setErrore("");
  }

  async function onSalvaForm() {
    setErrore("");
    setMessaggio("");
    const username = campoUsername.trim();
    if (!username || campoPassword.length < 4) {
      setErrore("Utente obbligatorio e password di almeno 4 caratteri.");
      return;
    }
    // Creando un'azienda l'azienda è quella appena scritta; aggiungendo un
    // utente dentro una tab è implicita — quella tab (mai ridigitata).
    const azienda = formAttivo === "azienda" ? campoAzienda.trim() : (tabAzienda === SENZA_AZIENDA ? "" : tabAzienda || "");
    if (formAttivo === "azienda" && !azienda) {
      setErrore("Inserisci il nome della nuova azienda.");
      return;
    }
    // Uno username già usato da un'ALTRA azienda non va spostato di striscio
    // qui dentro (sposterebbe per sbaglio un utente da un'azienda all'altra):
    // stesso username già in QUESTA azienda invece va bene, è un reset
    // password legittimo.
    const esistente = utenti.find((u) => u.username === username);
    if (esistente && (esistente.azienda || "") !== azienda) {
      setErrore(`L'utente "${username}" esiste già in un'altra azienda (${esistente.azienda || "senza azienda"}): scegli un altro nome utente.`);
      return;
    }
    setSalvataggio(true);
    try {
      // Un'azienda appena creata parte SEMPRE con la modalità mapping
      // spenta: è una scelta esplicita da attivare dopo (con conferma, vedi
      // alternaPermesso), mai un default che rischia di dare subito a un
      // cliente nuovo la possibilità di creare/modificare mappature.
      const puoMappareIniziale = formAttivo === "azienda" ? false : undefined;
      await salvaUtente({ username, password: campoPassword, azienda, puoMappare: puoMappareIniziale });
      setMessaggio(esistente ? "Password aggiornata." : (formAttivo === "azienda" ? `Azienda "${azienda}" creata.` : "Utente creato."));
      if (formAttivo === "azienda") setTabAzienda(azienda);
      setFormAttivo(null);
      ricarica();
      ricaricaAziende();
    } catch (e) {
      setErrore(e.message);
    } finally {
      setSalvataggio(false);
    }
  }

  // Il click/digitazione cambia solo la bozza in pagina, niente in rete finché
  // non si preme "Salva modifiche utenti": senza, non era chiaro se il
  // cambiamento fosse stato applicato davvero o solo mostrato in pagina.
  // ACCENDERE la modalità mapping (non spegnerla) chiede conferma: dà a
  // quell'utente la possibilità di creare/modificare mappature, quindi un
  // click sbagliato non deve attivarla senza accorgersene.
  function alternaPermesso(username, valoreAttuale) {
    if (!valoreAttuale && !window.confirm(`Attivare la modalità mapping per "${username}"? Potrà creare e modificare mappature/template.`)) {
      return;
    }
    setMessaggioPermessi("");
    setUtenti((prev) => prev.map((u) => (u.username === username ? { ...u, puoMappare: !valoreAttuale } : u)));
  }

  // Quali moduli (diba/ddt/ordini) questa azienda vede in "Cosa vuoi
  // importare?" — non più un'unica impostazione per tutta l'installazione
  // (vedi routes/auth.js moduliAttiviDiUtente): ogni azienda ha la sua.
  function alternaModuloUtente(username, chiave, valoreAttuale) {
    setMessaggioPermessi("");
    setUtenti((prev) => prev.map((u) => (
      u.username === username ? { ...u, moduliAttivi: { ...u.moduliAttivi, [chiave]: !valoreAttuale } } : u
    )));
  }

  function moduliDiversi(a, b) {
    return MODULI_ELENCO.some((m) => !!(a || {})[m.chiave] !== !!(b || {})[m.chiave]);
  }

  const utentiModificati = utenti.filter((u) => {
    const originale = utentiOriginali.find((o) => o.username === u.username);
    return originale && (
      originale.puoMappare !== u.puoMappare
      || (originale.azienda || "") !== (u.azienda || "")
      || moduliDiversi(originale.moduliAttivi, u.moduliAttivi)
    );
  });

  // Chiudere (✕ o Esc) con modifiche utenti ancora in bozza (non passate da
  // "Salva modifiche utenti") le butterebbe via senza che ce ne si accorga —
  // qui sotto si chiede conferma solo in quel caso, altrimenti si chiude
  // subito come prima. Spostato qui (dopo utentiModificati, non più in cima
  // al componente) apposta: l'effect deve vedere il valore SEMPRE aggiornato
  // di questo render, non quello "congelato" al primo montaggio.
  function chiediConfermaEChiudi() {
    if (utentiModificati.length > 0 && !window.confirm(
      `Ci sono ${utentiModificati.length} modifiche utenti non salvate: uscire comunque? (Annulla per tornare indietro e premere "Salva modifiche utenti")`
    )) {
      return;
    }
    onClose();
  }

  useEffect(() => {
    function onKeyDown(e) { if (e.key === "Escape") chiediConfermaEChiudi(); }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  });

  async function onSalvaPermessi() {
    setErrore("");
    setMessaggioPermessi("");
    setSalvataggioPermessi(true);
    try {
      await Promise.all(utentiModificati.flatMap((u) => {
        const originale = utentiOriginali.find((o) => o.username === u.username);
        const chiamate = [];
        if (originale.puoMappare !== u.puoMappare) chiamate.push(impostaPermessoMappatura(u.username, u.puoMappare));
        if ((originale.azienda || "") !== (u.azienda || "")) chiamate.push(impostaAziendaUtente(u.username, u.azienda || ""));
        if (moduliDiversi(originale.moduliAttivi, u.moduliAttivi)) chiamate.push(impostaModuliUtente(u.username, u.moduliAttivi));
        return chiamate;
      }));
      setMessaggioPermessi(utentiModificati.length === 1 ? "Modifica salvata." : "Modifiche salvate.");
      setUtentiOriginali(utenti);
      ricaricaAziende();
    } catch (e) {
      setErrore(e.message);
    } finally {
      setSalvataggioPermessi(false);
    }
  }

  async function onElimina(username) {
    if (!window.confirm(`Eliminare l'utente "${username}"?`)) return;
    setErrore("");
    try {
      await eliminaUtente(username);
      ricarica();
    } catch (e) {
      setErrore(e.message);
    }
  }

  // Una tab per azienda (wtrendy escluso, non compare in questa lista): il
  // raggruppamento usa SEMPRE l'azienda originale (utentiOriginali), non la
  // bozza in "utenti" — così scrivere nel campo "Azienda" di un utente non
  // lo fa sparire dalla tab corrente mentre si digita, solo dopo il salvataggio.
  function gruppoDi(u) {
    return (u.azienda || "").trim() || SENZA_AZIENDA;
  }
  const gruppiAzienda = [...new Set(utentiOriginali.filter((u) => u.username !== "wtrendy").map(gruppoDi))]
    .sort((a, b) => (a === SENZA_AZIENDA ? 1 : b === SENZA_AZIENDA ? -1 : a.localeCompare(b)));

  useEffect(() => {
    if (gruppiAzienda.length === 0) { setTabAzienda(null); return; }
    if (!tabAzienda || !gruppiAzienda.includes(tabAzienda)) setTabAzienda(gruppiAzienda[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [utentiOriginali]);

  const chiaviInTab = new Set(
    utentiOriginali.filter((u) => gruppoDi(u) === tabAzienda).map((u) => u.username)
  );
  const utentiTab = utenti.filter((u) => chiaviInTab.has(u.username));

  return (
    <div
      // Niente onClose qui: un click fuori dal pannello (anche per sbaglio,
      // es. mentre si scrive un'azienda) non deve buttare via tutto — si
      // chiude SOLO con la ✕ o Esc, mai per un click accidentale sullo sfondo.
      style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(15, 23, 42, 0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, fontFamily: "Inter, sans-serif" }}
    >
      <div
        style={{ backgroundColor: "var(--cf-bg-card)", borderRadius: "16px", width: "1140px", maxWidth: "96vw", height: "85vh", maxHeight: "85vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 25px 60px rgba(0,0,0,0.45)" }}
      >
        <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)", padding: "18px 22px", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "20px", lineHeight: 1 }}>⚙️</span>
            <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontWeight: 700, fontSize: "15px", letterSpacing: "1px", textTransform: "uppercase", color: "#f1f5f9" }}>
              Impostazioni
            </div>
          </div>
          <button
            className="cf-btn"
            onClick={chiediConfermaEChiudi}
            style={{ display: "flex", alignItems: "center", justifyContent: "center", border: "none", background: "rgba(255,255,255,0.08)", borderRadius: "6px", width: "28px", height: "28px", padding: 0, fontSize: "14px", cursor: "pointer", color: "#cbd5e1", lineHeight: 1 }}
          >
            ✕
          </button>
        </div>

          {/* Due colonne, ciascuna con lo scroll proprio: prima si scorreva
              tutto in verticale con la finestra stretta (440px), ora con più
              spazio orizzontale la lista lunga di template/modelli (a destra)
              non costringe a scrollare oltre "Crea nuovo utente" (a sinistra)
              per vederla, e viceversa. */}
          <div style={{ flex: 1, minHeight: 0, display: "grid", gridTemplateColumns: "480px 1fr", gap: "0", overflow: "hidden" }}>
          <div style={{ padding: "26px 24px", overflowY: "auto", overflowX: "hidden", minWidth: 0, borderRight: "1px solid var(--cf-border)" }}>
            <div style={{ fontSize: "11px", fontWeight: 700, color: "var(--cf-text-muted)", textTransform: "uppercase", letterSpacing: "0.6px", marginBottom: "12px", fontFamily: "'Roboto Mono', Consolas, monospace" }}>
              Utenti / Aziende
            </div>

            {caricamento ? (
              <p style={{ color: "var(--cf-text-muted)", fontSize: "13px" }}>Caricamento...</p>
            ) : (
              <>
                {/* Una tab per azienda: sotto ciascuna, tutti i suoi utenti
                    con i permessi propri (un'azienda può avere più utenti,
                    es. uno solo abilitato a mappare). wtrendy non compare
                    mai qui: è l'admin fisso, non gestibile da questa lista.
                    "+ Nuova azienda" è sempre nella barra, anche a lista
                    vuota: è l'unico modo di crearne la primissima. */}
                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "12px" }}>
                  {gruppiAzienda.map((g) => {
                    const conteggio = utentiOriginali.filter((u) => gruppoDi(u) === g).length;
                    const attiva = formAttivo !== "azienda" && tabAzienda === g;
                    return (
                      <button
                        key={g}
                        onClick={() => { setTabAzienda(g); if (formAttivo === "azienda") chiudiForm(); }}
                        style={{
                          padding: "7px 12px", borderRadius: "6px", cursor: "pointer",
                          border: `1px solid ${attiva ? "#1e3a8a" : "var(--cf-border-strong)"}`,
                          backgroundColor: attiva ? "#1e3a8a" : "var(--cf-bg-subtle)",
                          color: attiva ? "#fff" : "var(--cf-text-muted)",
                          fontSize: "12px", fontWeight: 700, fontFamily: "'Roboto Mono', Consolas, monospace",
                        }}
                      >
                        {g === SENZA_AZIENDA ? "Senza azienda" : g} ({conteggio})
                      </button>
                    );
                  })}
                  <button
                    onClick={apriFormNuovaAzienda}
                    style={{
                      padding: "7px 12px", borderRadius: "6px", cursor: "pointer",
                      border: `1px dashed ${formAttivo === "azienda" ? "#1e3a8a" : "var(--cf-border-strong)"}`,
                      backgroundColor: formAttivo === "azienda" ? "var(--cf-bg-subtle)" : "transparent",
                      color: formAttivo === "azienda" ? "#1e3a8a" : "var(--cf-text-muted)",
                      fontSize: "12px", fontWeight: 700, fontFamily: "'Roboto Mono', Consolas, monospace",
                    }}
                  >
                    + Nuova azienda
                  </button>
                </div>

                {messaggio && <p style={{ color: "#16a34a", fontSize: "13px", margin: "0 0 10px" }}>{messaggio}</p>}

                {formAttivo === "azienda" ? (
                  <FormCreaUtente
                    titolo="Nuova azienda"
                    mostraCampoAzienda
                    campoAzienda={campoAzienda}
                    setCampoAzienda={setCampoAzienda}
                    campoUsername={campoUsername}
                    setCampoUsername={setCampoUsername}
                    campoPassword={campoPassword}
                    setCampoPassword={setCampoPassword}
                    onSalva={onSalvaForm}
                    onAnnulla={chiudiForm}
                    salvataggio={salvataggio}
                    errore={errore}
                    testoSalva="CREA AZIENDA"
                  />
                ) : gruppiAzienda.length === 0 ? (
                  <p style={{ color: "var(--cf-text-muted)", fontSize: "13px", marginBottom: "18px" }}>
                    Nessuna azienda ancora (a parte wtrendy): crea la prima con "+ Nuova azienda" qui sopra.
                  </p>
                ) : (
                  <>
                    <div style={{ fontSize: "14px", fontWeight: 700, color: "var(--cf-text-primary)", marginBottom: "8px" }}>
                      🏢 {tabAzienda === SENZA_AZIENDA ? "Senza azienda" : tabAzienda}
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginBottom: "12px" }}>
                      {utentiTab.map((u) => (
                      <div key={u.username} style={{ display: "flex", flexDirection: "column", gap: "6px", padding: "8px 12px", borderRadius: "8px", border: "1px solid var(--cf-border)", backgroundColor: "var(--cf-bg-subtle)" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span style={{ fontSize: "13px", color: "var(--cf-text-primary)", fontWeight: 600 }}>
                              {u.username}
                            </span>
                            <button
                              className="cf-btn"
                              onClick={() => onElimina(u.username)}
                              title="Elimina utente"
                              style={{ border: "none", background: "none", color: "var(--cf-danger-text)", cursor: "pointer", fontSize: "12px", textDecoration: "underline" }}
                            >
                              Elimina
                            </button>
                          </div>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px" }}>
                                <span style={{ fontSize: "12px", color: "var(--cf-text-muted)" }} title="Se disattivato può solo scegliere un template già esistente e applicarlo, non creare o modificare mappature">
                                  Attivazione modalità mapping
                                </span>
                                <button
                                  type="button"
                                  onClick={() => alternaPermesso(u.username, u.puoMappare)}
                                  disabled={salvataggioPermessi}
                                  role="switch"
                                  aria-checked={u.puoMappare}
                                  aria-label="Attivazione modalità mapping"
                                  style={{
                                    width: "36px", height: "20px", borderRadius: "10px", position: "relative", flexShrink: 0,
                                    border: "none", cursor: salvataggioPermessi ? "wait" : "pointer", padding: 0,
                                    backgroundColor: u.puoMappare ? "#22d3ee" : "var(--cf-border-strong)",
                                    transition: "background-color 0.15s ease",
                                  }}
                                >
                                  <span
                                    style={{
                                      position: "absolute", top: "2px", width: "16px", height: "16px", borderRadius: "50%", backgroundColor: "#fff",
                                      left: u.puoMappare ? "18px" : "2px",
                                      transition: "left 0.15s ease",
                                    }}
                                  />
                                </button>
                              </div>
                              <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "10px", fontSize: "12px", color: "var(--cf-text-muted)" }}>
                                Moduli:
                                {MODULI_ELENCO.map((m) => {
                                  const attivo = (u.moduliAttivi || {})[m.chiave] !== false;
                                  return (
                                    <label key={m.chiave} title={m.etichetta} style={{ display: "flex", alignItems: "center", gap: "5px", cursor: "pointer", whiteSpace: "nowrap" }}>
                                      <input
                                        type="checkbox"
                                        checked={attivo}
                                        disabled={salvataggioPermessi}
                                        onChange={() => alternaModuloUtente(u.username, m.chiave, attivo)}
                                      />
                                      {m.icona} {m.etichettaBreve}
                                    </label>
                                  );
                                })}
                              </div>
                      </div>
                      ))}
                    </div>

                    {formAttivo === "utente" ? (
                      <FormCreaUtente
                        titolo={`Nuovo utente in "${tabAzienda === SENZA_AZIENDA ? "Senza azienda" : tabAzienda}"`}
                        campoUsername={campoUsername}
                        setCampoUsername={setCampoUsername}
                        campoPassword={campoPassword}
                        setCampoPassword={setCampoPassword}
                        onSalva={onSalvaForm}
                        onAnnulla={chiudiForm}
                        salvataggio={salvataggio}
                        errore={errore}
                        testoSalva="SALVA UTENTE"
                      />
                    ) : (
                      <button
                        className="cf-btn"
                        onClick={apriFormNuovoUtente}
                        style={{
                          width: "100%", padding: "9px", borderRadius: "8px", marginBottom: "18px", cursor: "pointer",
                          border: "1px dashed var(--cf-border-strong)", backgroundColor: "transparent",
                          color: "var(--cf-text-muted)", fontSize: "12px", fontWeight: 700, fontFamily: "'Roboto Mono', Consolas, monospace",
                        }}
                      >
                        + Aggiungi utente {tabAzienda === SENZA_AZIENDA ? "" : `a "${tabAzienda}"`}
                      </button>
                    )}

                    {tabAzienda !== SENZA_AZIENDA && <SezioneSviluppiAzienda azienda={tabAzienda} />}
                    {tabAzienda !== SENZA_AZIENDA && (
                      <LanciatoreConversioneCodici azienda={tabAzienda} onNavigare={() => { onClose(); navigate(`/ordini/conversione-codici?azienda=${encodeURIComponent(tabAzienda)}`); }} />
                    )}
                  </>
                )}
              </>
            )}
            {messaggioPermessi && <p style={{ color: "#16a34a", fontSize: "13px", margin: "0 0 10px" }}>{messaggioPermessi}</p>}
            <button
              className="cf-btn"
              onClick={onSalvaPermessi}
              disabled={salvataggioPermessi || utentiModificati.length === 0}
              style={{
                width: "100%", padding: "10px", borderRadius: "8px",
                border: "1px solid var(--cf-border-strong)", backgroundColor: utentiModificati.length > 0 ? "#1e3a8a" : "var(--cf-bg-subtle)",
                color: utentiModificati.length > 0 ? "#fff" : "var(--cf-text-muted)",
                cursor: salvataggioPermessi ? "wait" : (utentiModificati.length > 0 ? "pointer" : "not-allowed"),
                fontWeight: 700, fontFamily: "'Roboto Mono', Consolas, monospace", letterSpacing: "0.8px", fontSize: "13px",
              }}
            >
              {salvataggioPermessi ? "SALVATAGGIO..." : "SALVA MODIFICHE UTENTI"}
            </button>
          </div>

          <div style={{ padding: "26px 24px", overflowY: "auto", overflowX: "hidden", minWidth: 0 }}>
            <div style={{ fontSize: "11px", fontWeight: 700, color: "var(--cf-text-muted)", textTransform: "uppercase", letterSpacing: "0.6px", marginBottom: "4px", fontFamily: "'Roboto Mono', Consolas, monospace" }}>
              Assegna template e modelli alle aziende
            </div>
            <p style={{ fontSize: "12px", color: "var(--cf-text-muted)", margin: "0 0 12px" }}>
              Ogni template/modello è visibile solo alle aziende selezionate qui sotto (può essere più di una, es. due
              terzisti dello stesso brand).
            </p>
            <SezioneRisorse
              risorse={risorse}
              caricamento={caricamentoRisorse}
              errore={erroreRisorse}
              onSalvato={ricaricaRisorse}
              aziendeNote={aziendeNote}
            />
          </div>
          </div>
      </div>
    </div>
  );
}

const STILE_CAMPO_FORM = {
  width: "100%", boxSizing: "border-box", padding: "9px 12px", borderRadius: "8px",
  border: "1px solid var(--cf-border-strong)", backgroundColor: "var(--cf-bg-card)",
  color: "var(--cf-text-primary)", fontSize: "13px", marginBottom: "8px",
};

// Form di creazione condiviso tra "+ Nuova azienda" (mostraCampoAzienda: in
// più chiede il nome della nuova azienda) e "+ Aggiungi utente" dentro una
// tab già aperta (l'azienda è implicita, quella tab — non si ridigita mai):
// vedi apriFormNuovaAzienda/apriFormNuovoUtente/onSalvaForm più sopra.
function FormCreaUtente({
  titolo, mostraCampoAzienda, campoAzienda, setCampoAzienda,
  campoUsername, setCampoUsername, campoPassword, setCampoPassword,
  onSalva, onAnnulla, salvataggio, errore, testoSalva,
}) {
  return (
    <div style={{ padding: "12px", borderRadius: "8px", border: "1px solid var(--cf-border-strong)", backgroundColor: "var(--cf-bg-subtle)", marginBottom: "18px" }}>
      <div style={{ fontSize: "12px", fontWeight: 700, color: "var(--cf-text-primary)", marginBottom: "8px" }}>{titolo}</div>
      {mostraCampoAzienda && (
        <input
          type="text"
          autoFocus
          placeholder="Nome azienda"
          value={campoAzienda}
          onChange={(e) => setCampoAzienda(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") onSalva(); }}
          style={STILE_CAMPO_FORM}
        />
      )}
      <input
        type="text"
        autoFocus={!mostraCampoAzienda}
        placeholder="Nome utente"
        value={campoUsername}
        onChange={(e) => setCampoUsername(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") onSalva(); }}
        style={STILE_CAMPO_FORM}
      />
      <input
        type="password"
        placeholder="Password (min. 4 caratteri)"
        value={campoPassword}
        onChange={(e) => setCampoPassword(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") onSalva(); }}
        style={{ ...STILE_CAMPO_FORM, marginBottom: "10px", fontFamily: "'Roboto Mono', Consolas, monospace" }}
      />
      {errore && <p style={{ color: "var(--cf-danger-text)", fontSize: "12px", margin: "0 0 8px" }}>{errore}</p>}
      <div style={{ display: "flex", gap: "8px" }}>
        <button
          className="cf-btn"
          onClick={onSalva}
          disabled={salvataggio}
          style={{ flex: 1, padding: "9px", borderRadius: "8px", border: "none", backgroundColor: "#1e3a8a", color: "#fff", cursor: salvataggio ? "wait" : "pointer", fontWeight: 700, fontFamily: "'Roboto Mono', Consolas, monospace", letterSpacing: "0.6px", fontSize: "12px", opacity: salvataggio ? 0.7 : 1 }}
        >
          {salvataggio ? "SALVATAGGIO..." : testoSalva}
        </button>
        <button
          className="cf-btn"
          onClick={onAnnulla}
          disabled={salvataggio}
          style={{ padding: "9px 14px", borderRadius: "8px", border: "1px solid var(--cf-border-strong)", backgroundColor: "transparent", color: "var(--cf-text-muted)", cursor: salvataggio ? "wait" : "pointer", fontSize: "12px" }}
        >
          Annulla
        </button>
      </div>
    </div>
  );
}

// Tab per modulo (stessa chiave/etichetta/icona di MODULI_ELENCO): con tutto
// mescolato insieme (Distinta Base + Ordini + DDT, template e modelli PDF)
// la lista era confusionaria — divisa per modulo si trova subito quello che
// si sta cercando, e dentro ogni tab Template e Modelli PDF sono due gruppi
// separati invece di comparire mescolati in una sola griglia.
//
// Bozza + un solo salvataggio per tab (invece di un salva per riga): editare
// il campo di una riga cambia solo lo stato qui in pagina, come per
// permessi/moduli più sopra — altrimenti ogni singolo "Salva" ricaricava
// TUTTA la lista (richiesta al server + re-render), facendo perdere lo
// scroll e la posizione ad ogni click.
const CHIAVE_RISORSA = (r) => `${r.tipo}|${r.modulo}|${r.id}`;

function SezioneRisorse({ risorse, caricamento, errore, onSalvato, aziendeNote }) {
  const [tabAttiva, setTabAttiva] = useState("diba");
  // { [chiaveRisorsa]: aziende modificate, come stringa "A, B" — stesso
  // formato con cui arrivano dal server (aziende.join(", ")), così il
  // confronto con l'originale per capire cosa è cambiato resta un semplice
  // confronto di stringhe.
  const [modifiche, setModifiche] = useState({});
  const [salvataggio, setSalvataggio] = useState(false);
  const [erroreSalvataggio, setErroreSalvataggio] = useState("");
  const [messaggioSalvataggio, setMessaggioSalvataggio] = useState("");

  if (caricamento) return <p style={{ color: "var(--cf-text-muted)", fontSize: "13px" }}>Caricamento...</p>;
  if (errore) return <p style={{ color: "var(--cf-danger-text)", fontSize: "13px" }}>{errore}</p>;
  if (risorse.length === 0) return <p style={{ color: "var(--cf-text-muted)", fontSize: "13px" }}>Nessun template o modello salvato ancora.</p>;

  const risorseTab = risorse.filter((r) => r.modulo === tabAttiva);
  const template = risorseTab.filter((r) => r.tipo === "template");
  const modelliPdf = risorseTab.filter((r) => r.tipo === "modello-pdf");

  function testoAttuale(r) {
    const chiave = CHIAVE_RISORSA(r);
    return chiave in modifiche ? modifiche[chiave] : (r.aziende || []).join(", ");
  }

  function onCambiaTesto(r, testo) {
    setMessaggioSalvataggio("");
    setModifiche((prev) => ({ ...prev, [CHIAVE_RISORSA(r)]: testo }));
  }

  // Solo le risorse DI QUESTA TAB con un testo davvero diverso dall'originale
  // — cambiare tab non fa perdere le modifiche fatte altrove (restano in
  // "modifiche"), ma "Salva" qui salva solo quelle visibili adesso.
  const modificateInQuestaTab = risorseTab.filter((r) => {
    const chiave = CHIAVE_RISORSA(r);
    if (!(chiave in modifiche)) return false;
    return modifiche[chiave].trim() !== (r.aziende || []).join(", ");
  });

  async function onSalvaTab() {
    setErroreSalvataggio("");
    setMessaggioSalvataggio("");
    setSalvataggio(true);
    try {
      await Promise.all(modificateInQuestaTab.map((r) => {
        const aziende = modifiche[CHIAVE_RISORSA(r)].split(",").map((a) => a.trim()).filter(Boolean);
        return assegnaAziendeRisorsa({ tipo: r.tipo, modulo: r.modulo, id: r.id, aziende });
      }));
      // Le chiavi appena salvate si tolgono dalla bozza (il valore ricaricato
      // da onSalvato() coincide ormai con quello appena scritto): eventuali
      // modifiche non salvate su ALTRE tab restano intatte.
      setModifiche((prev) => {
        const rimaste = { ...prev };
        modificateInQuestaTab.forEach((r) => delete rimaste[CHIAVE_RISORSA(r)]);
        return rimaste;
      });
      setMessaggioSalvataggio(modificateInQuestaTab.length === 1 ? "Assegnazione salvata." : "Assegnazioni salvate.");
      onSalvato();
    } catch (e) {
      setErroreSalvataggio(e.message);
    } finally {
      setSalvataggio(false);
    }
  }

  return (
    <div>
      <div style={{ display: "flex", gap: "6px", marginBottom: "12px" }}>
        {MODULI_ELENCO.map((m) => {
          const conteggio = risorse.filter((r) => r.modulo === m.chiave).length;
          const attiva = tabAttiva === m.chiave;
          return (
            <button
              key={m.chiave}
              onClick={() => { setTabAttiva(m.chiave); setMessaggioSalvataggio(""); }}
              style={{
                flex: 1, padding: "8px 10px", borderRadius: "6px", cursor: "pointer",
                border: `1px solid ${attiva ? "#1e3a8a" : "var(--cf-border-strong)"}`,
                backgroundColor: attiva ? "#1e3a8a" : "var(--cf-bg-subtle)",
                color: attiva ? "#fff" : "var(--cf-text-muted)",
                fontSize: "12px", fontWeight: 700, fontFamily: "'Roboto Mono', Consolas, monospace",
              }}
            >
              {m.icona} {m.etichetta} ({conteggio})
            </button>
          );
        })}
      </div>
      {risorseTab.length === 0 ? (
        <p style={{ color: "var(--cf-text-muted)", fontSize: "13px" }}>Nessun template o modello salvato per questo modulo.</p>
      ) : (
        <>
          <GruppoRisorse titolo="Template" risorse={template} testoAttuale={testoAttuale} onCambiaTesto={onCambiaTesto} disabilitato={salvataggio} aziendeNote={aziendeNote} soloUnaAzienda={tabAttiva === "ordini"} />
          <GruppoRisorse titolo="Modelli PDF" risorse={modelliPdf} testoAttuale={testoAttuale} onCambiaTesto={onCambiaTesto} disabilitato={salvataggio} aziendeNote={aziendeNote} />
          {erroreSalvataggio && <p style={{ color: "var(--cf-danger-text)", fontSize: "12px", margin: "4px 0 0" }}>{erroreSalvataggio}</p>}
          {messaggioSalvataggio && <p style={{ color: "#16a34a", fontSize: "12px", margin: "4px 0 0" }}>{messaggioSalvataggio}</p>}
          <button
            className="cf-btn"
            onClick={onSalvaTab}
            disabled={salvataggio || modificateInQuestaTab.length === 0}
            style={{
              width: "100%", padding: "10px", borderRadius: "8px", marginTop: "10px",
              border: "1px solid var(--cf-border-strong)", backgroundColor: modificateInQuestaTab.length > 0 ? "#1e3a8a" : "var(--cf-bg-subtle)",
              color: modificateInQuestaTab.length > 0 ? "#fff" : "var(--cf-text-muted)",
              cursor: salvataggio ? "wait" : (modificateInQuestaTab.length > 0 ? "pointer" : "not-allowed"),
              fontWeight: 700, fontFamily: "'Roboto Mono', Consolas, monospace", letterSpacing: "0.8px", fontSize: "13px",
            }}
          >
            {salvataggio ? "SALVATAGGIO..." : "SALVA ASSEGNAZIONI"}
          </button>
        </>
      )}
    </div>
  );
}

function GruppoRisorse({ titolo, risorse, testoAttuale, onCambiaTesto, disabilitato, aziendeNote, soloUnaAzienda }) {
  if (risorse.length === 0) return null;
  return (
    <div style={{ marginBottom: "14px" }}>
      <div style={{ fontSize: "10px", fontWeight: 700, color: "var(--cf-text-faint)", textTransform: "uppercase", letterSpacing: "0.6px", margin: "0 0 6px" }}>
        {titolo} ({risorse.length})
      </div>
      {soloUnaAzienda && (
        <p style={{ fontSize: "11px", color: "var(--cf-text-muted)", margin: "0 0 6px" }}>
          Un template Ordini va assegnato a una sola azienda: ha una sigla import unica e fissa, che due aziende non
          possono condividere.
        </p>
      )}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
        {risorse.map((r) => (
          <RigaRisorsa key={CHIAVE_RISORSA(r)} risorsa={r} valore={testoAttuale(r)} onChange={(t) => onCambiaTesto(r, t)} disabilitato={disabilitato} aziendeNote={aziendeNote} soloUnaAzienda={soloUnaAzienda} />
        ))}
      </div>
    </div>
  );
}

function RigaRisorsa({ risorsa, valore, onChange, disabilitato, aziendeNote, soloUnaAzienda }) {
  return (
    // minWidth:0 su ogni livello che deve poter restringersi: un elemento
    // grid/flex di default non si restringe sotto la larghezza del proprio
    // contenuto, che altrimenti spinge fuori la colonna e crea uno scroll
    // orizzontale indesiderato.
    <div style={{ display: "flex", flexDirection: "column", gap: "4px", padding: "8px 12px", borderRadius: "8px", border: "1px solid var(--cf-border)", backgroundColor: "var(--cf-bg-subtle)", minWidth: 0, overflow: "visible" }}>
      <span style={{ fontSize: "13px", color: "var(--cf-text-primary)", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 }}>
        {risorsa.cliente || "(senza nome)"}
      </span>
      <SelettoreAziende valore={valore} onChange={onChange} opzioni={aziendeNote} disabilitato={disabilitato} singola={soloUnaAzienda} />
    </div>
  );
}

// Tendina con una checkbox per azienda (invece di digitare un elenco
// separato da virgole): meno probabilità di errori di battitura, e si vede
// subito quali aziende esistono già invece di doverle ricordare a memoria.
// "valore"/"onChange" restano una stringa "A, B" (stesso formato del server,
// anche in modalità "singola" — sempre al più un nome dentro) per non dover
// cambiare la logica di bozza/confronto in SezioneRisorse.
//
// singola: un template Ordini ha una SOLA sigla import, generata una volta
// sola e fissa per sempre (vedi routes/ordini.js) — assegnarlo a più
// aziende le farebbe condividere la stessa sigla, che invece deve essere
// unica per azienda. Qui diventa una scelta esclusiva (radio, non
// checkbox): selezionarne una sostituisce l'eventuale precedente invece di
// aggiungersi. I modelli PDF e i template Distinta Base/DDT restano invece
// multi-selezione come sempre (es. due terzisti dello stesso brand).
function SelettoreAziende({ valore, onChange, opzioni, disabilitato, singola }) {
  const [aperto, setAperto] = useState(false);
  const riferimento = useRef(null);
  const selezionate = valore ? valore.split(",").map((a) => a.trim()).filter(Boolean) : [];

  useEffect(() => {
    if (!aperto) return;
    function onClickFuori(e) {
      if (riferimento.current && !riferimento.current.contains(e.target)) setAperto(false);
    }
    document.addEventListener("mousedown", onClickFuori);
    return () => document.removeEventListener("mousedown", onClickFuori);
  }, [aperto]);

  function alterna(azienda) {
    if (singola) {
      onChange(selezionate[0] === azienda ? "" : azienda);
      setAperto(false);
      return;
    }
    const nuove = selezionate.includes(azienda)
      ? selezionate.filter((a) => a !== azienda)
      : [...selezionate, azienda];
    onChange(nuove.join(", "));
  }

  return (
    <div ref={riferimento} style={{ position: "relative", minWidth: 0 }}>
      <button
        type="button"
        disabled={disabilitato}
        onClick={() => setAperto((v) => !v)}
        style={{
          width: "100%", boxSizing: "border-box", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "6px",
          padding: "6px 8px", borderRadius: "6px", border: "1px solid var(--cf-border-strong)", backgroundColor: "var(--cf-bg-card)",
          color: selezionate.length > 0 ? "var(--cf-text-primary)" : "var(--cf-text-faint)", fontSize: "12px",
          cursor: disabilitato ? "not-allowed" : "pointer",
        }}
      >
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 }}>
          {selezionate.length > 0 ? selezionate.join(", ") : "nessuna azienda assegnata"}
        </span>
        <span style={{ flexShrink: 0, fontSize: "9px", opacity: 0.7 }}>{aperto ? "▲" : "▼"}</span>
      </button>
      {aperto && (
        <div style={{
          position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, zIndex: 20,
          backgroundColor: "var(--cf-bg-card)", border: "1px solid var(--cf-border-strong)", borderRadius: "6px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.3)", maxHeight: "170px", overflowY: "auto", padding: "4px",
        }}>
          {opzioni.length === 0 ? (
            <div style={{ padding: "6px 8px", fontSize: "12px", color: "var(--cf-text-muted)" }}>Nessuna azienda creata ancora.</div>
          ) : opzioni.map((azienda) => (
            <label
              key={azienda}
              style={{ display: "flex", alignItems: "center", gap: "8px", padding: "5px 6px", fontSize: "12px", color: "var(--cf-text-primary)", cursor: "pointer", borderRadius: "4px" }}
            >
              <input
                type={singola ? "radio" : "checkbox"}
                checked={selezionate.includes(azienda)}
                onChange={() => alterna(azienda)}
              />
              {azienda}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}

// Vocabolario sviluppi (colonna Taglia_NomeCalzata di Import Ordini) per
// l'azienda della tab aperta: SOLO wtrendy può crearli/toglierli (vedi
// routes/ordini.js) — l'operatore, da OrdiniMapping.jsx, può solo abbinarci
// i valori trovati nei file (mai inventarne di nuovi), per non rischiare che
// un dato sbagliato finisca sul vocabolario dell'ERP. Qui in più si vedono
// le corrispondenze che gli operatori hanno già creato (sola lettura: sono
// un log di cosa è stato deciso, non qualcosa da editare da qui).
function SezioneSviluppiAzienda({ azienda }) {
  const [legenda, setLegenda] = useState({ sviluppi: [], mappature: {} });
  const [caricamento, setCaricamento] = useState(true);
  const [erroreCaricamento, setErroreCaricamento] = useState("");
  const [testoLista, setTestoLista] = useState("");
  const [nuovoSingolo, setNuovoSingolo] = useState("");
  const [salvataggio, setSalvataggio] = useState(false);
  const [messaggio, setMessaggio] = useState("");
  const [erroreSalvataggio, setErroreSalvataggio] = useState("");

  useEffect(() => {
    setCaricamento(true);
    setErroreCaricamento("");
    setMessaggio("");
    getLegendaSviluppi(azienda)
      .then(setLegenda)
      .catch((e) => setErroreCaricamento(e.message))
      .finally(() => setCaricamento(false));
  }, [azienda]);

  async function caricaLista() {
    const righe = testoLista.split("\n").map((r) => r.trim()).filter(Boolean);
    if (righe.length === 0) return;
    setErroreSalvataggio("");
    setMessaggio("");
    setSalvataggio(true);
    try {
      const aggiornata = await salvaSviluppiAzienda(azienda, righe);
      setLegenda(aggiornata);
      setTestoLista("");
      setMessaggio(`${righe.length} valori inviati (quelli già presenti sono stati ignorati).`);
    } catch (e) {
      setErroreSalvataggio(e.message);
    } finally {
      setSalvataggio(false);
    }
  }

  async function aggiungiSingolo() {
    const testo = nuovoSingolo.trim();
    if (!testo) return;
    setErroreSalvataggio("");
    setMessaggio("");
    setSalvataggio(true);
    try {
      const aggiornata = await salvaSviluppiAzienda(azienda, [testo]);
      setLegenda(aggiornata);
      setNuovoSingolo("");
    } catch (e) {
      setErroreSalvataggio(e.message);
    } finally {
      setSalvataggio(false);
    }
  }

  async function togli(nome) {
    if (!window.confirm(`Togliere "${nome}" dal vocabolario? Le corrispondenze già create verso questo sviluppo verranno tolte anche loro.`)) return;
    setErroreSalvataggio("");
    setMessaggio("");
    setSalvataggio(true);
    try {
      const aggiornata = await eliminaSviluppoAzienda(azienda, nome);
      setLegenda(aggiornata);
    } catch (e) {
      setErroreSalvataggio(e.message);
    } finally {
      setSalvataggio(false);
    }
  }

  const mappatureElenco = Object.entries(legenda.mappature || {});

  return (
    <div style={{ marginTop: "18px", padding: "14px", borderRadius: "8px", border: "1px solid var(--cf-border-strong)", backgroundColor: "var(--cf-bg-subtle)" }}>
      <div style={{ fontSize: "12px", fontWeight: 700, color: "var(--cf-text-primary)", marginBottom: "4px" }}>
        🔤 Sviluppi Import Ordini
      </div>
      <p style={{ fontSize: "11px", color: "var(--cf-text-muted)", margin: "0 0 10px" }}>
        Il vocabolario "nome sviluppo" valido per l'ERP di <strong>{azienda}</strong> (colonna Taglia_NomeSviluppo) —
        gli operatori di questa azienda possono solo abbinarci i valori trovati nei file, mai crearne di nuovi.
      </p>

      {caricamento ? (
        <p style={{ color: "var(--cf-text-muted)", fontSize: "12px" }}>Caricamento...</p>
      ) : erroreCaricamento ? (
        <p style={{ color: "var(--cf-danger-text)", fontSize: "12px" }}>{erroreCaricamento}</p>
      ) : (
        <>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "10px" }}>
            {legenda.sviluppi.length === 0 ? (
              <span style={{ fontSize: "12px", color: "var(--cf-text-muted)" }}>Nessuno sviluppo caricato ancora.</span>
            ) : legenda.sviluppi.map((s) => (
              <span key={s} style={{ display: "inline-flex", alignItems: "center", gap: "4px", padding: "3px 7px", borderRadius: "999px", backgroundColor: "var(--cf-bg-card)", border: "1px solid var(--cf-border-strong)", fontSize: "11px" }}>
                {s}
                <button
                  onClick={() => togli(s)}
                  disabled={salvataggio}
                  title={`Togli "${s}" dal vocabolario`}
                  style={{ border: "none", background: "none", cursor: salvataggio ? "wait" : "pointer", padding: 0, lineHeight: 1, color: "var(--cf-text-faint)" }}
                >
                  ✕
                </button>
              </span>
            ))}
          </div>

          <div style={{ display: "flex", gap: "6px", marginBottom: "8px" }}>
            <input
              type="text"
              placeholder="nuovo sviluppo singolo..."
              value={nuovoSingolo}
              onChange={(e) => setNuovoSingolo(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") aggiungiSingolo(); }}
              disabled={salvataggio}
              style={{ ...STILE_CAMPO_FORM, marginBottom: 0, flex: 1 }}
            />
            <button className="cf-btn" onClick={aggiungiSingolo} disabled={salvataggio || !nuovoSingolo.trim()} style={{ padding: "0 12px", borderRadius: "6px", border: "1px solid var(--cf-border-strong)", backgroundColor: "var(--cf-bg-card)", color: "var(--cf-text-primary)", fontSize: "12px", cursor: salvataggio ? "wait" : "pointer" }}>
              + aggiungi
            </button>
          </div>

          <label style={{ fontSize: "11px", color: "var(--cf-text-muted)", display: "block", marginBottom: "4px" }}>
            Oppure incolla una lista intera (uno sviluppo per riga):
          </label>
          <textarea
            value={testoLista}
            onChange={(e) => setTestoLista(e.target.value)}
            placeholder={"18M-3A\n1M-12A\nELEMENTARE 6A-14A\n1-24M"}
            rows={4}
            disabled={salvataggio}
            style={{ ...STILE_CAMPO_FORM, marginBottom: "6px", fontFamily: "'Roboto Mono', Consolas, monospace", resize: "vertical" }}
          />
          <button
            className="cf-btn"
            onClick={caricaLista}
            disabled={salvataggio || testoLista.trim() === ""}
            style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid var(--cf-border-strong)", backgroundColor: testoLista.trim() ? "#1e3a8a" : "var(--cf-bg-card)", color: testoLista.trim() ? "#fff" : "var(--cf-text-muted)", fontSize: "12px", fontWeight: 700, cursor: salvataggio ? "wait" : "pointer" }}
          >
            {salvataggio ? "Caricamento..." : "Carica lista"}
          </button>

          {erroreSalvataggio && <p style={{ color: "var(--cf-danger-text)", fontSize: "12px", margin: "8px 0 0" }}>{erroreSalvataggio}</p>}
          {messaggio && <p style={{ color: "#16a34a", fontSize: "12px", margin: "8px 0 0" }}>{messaggio}</p>}

          <div style={{ fontSize: "11px", fontWeight: 700, color: "var(--cf-text-muted)", textTransform: "uppercase", letterSpacing: "0.5px", margin: "16px 0 6px" }}>
            Corrispondenze create dagli operatori ({mappatureElenco.length})
          </div>
          {mappatureElenco.length === 0 ? (
            <p style={{ fontSize: "12px", color: "var(--cf-text-muted)" }}>Nessuna ancora.</p>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "3px", maxHeight: "160px", overflowY: "auto" }}>
              {mappatureElenco.map(([grezzo, sviluppo]) => (
                <div key={grezzo} style={{ display: "flex", justifyContent: "space-between", gap: "8px", fontSize: "11px", padding: "3px 6px", borderRadius: "4px", backgroundColor: "var(--cf-bg-card)" }}>
                  <span style={{ color: "var(--cf-text-muted)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{grezzo}</span>
                  <span style={{ color: "var(--cf-text-primary)", fontWeight: 600, flexShrink: 0 }}>→ {sviluppo}</span>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

// Lancia la pagina dedicata "/ordini/conversione-codici" (invece di un
// riquadro annidato qui dentro): con molte associazioni serviva un'area più
// grande, con filtro veloce e cancellazione multipla — vedi
// src/pages/ConversioneCodici.jsx. Il modale Impostazioni si chiude prima di
// navigare, altrimenti resterebbe sovrapposto alla nuova pagina.
function LanciatoreConversioneCodici({ azienda, onNavigare }) {
  return (
    <div style={{ marginTop: "12px" }}>
      <button
        className="cf-btn"
        onClick={onNavigare}
        style={{ padding: "6px 12px", borderRadius: "6px", border: "1px solid var(--cf-border-strong)", backgroundColor: "var(--cf-bg-card)", color: "var(--cf-text-primary)", fontSize: "12px", cursor: "pointer" }}
      >
        🔀 Conversione codici — gestisci le associazioni di "{azienda}"
      </button>
    </div>
  );
}

